import { createApi, fetchBaseQuery, retry } from "@reduxjs/toolkit/query/react";
import getBaseUrl from "../getBaseUrl";

const maxRetries = 2;

const baseQuery = retry(fetchBaseQuery(), { maxRetries });

export const leadingZeroesAPI = createApi({
  reducerPath: "leadingZeroesAPI",
  baseQuery,
  keepUnusedDataFor: 0,
  tagTypes: ["tagGetLeadingZeroes"],
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    //* *********************************************************** */
    //* GET LEADING ZEROES */
    getLeadingZeroes: builder.query({
      query: (body: any) => ({
        url: `${getBaseUrl()}/leading-zeroes/?&page=1&limit=99999`,
        headers: { authorization: body.token },
      }),
      providesTags: ["tagGetLeadingZeroes"],
    }),
    //* *********************************************************** */
    //* POST LEADING ZEROES */
    postLeadingZeroes: builder.mutation({
      query: (body: any) => ({
        url: `${getBaseUrl()}/leading-zeroes/`,
        method: "post",
        body: body.body,
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetLeadingZeroes"],
    }),
    //* *********************************************************** */
    //* PUT LEADING ZEROES */
    putLeadingZeroes: builder.mutation({
      query: (body: any) => ({
        url: `${getBaseUrl()}/leading-zeroes/${body.id}`,
        method: "put",
        body: body.body,
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetLeadingZeroes"],
    }),
    //* *********************************************************** */
    //* DELETE LEADING ZEROES */
    deleteLeadingZeroes: builder.mutation({
      query: (body: any) => ({
        url: `${getBaseUrl()}/leading-zeroes/${body.id}`,
        method: "delete",
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetLeadingZeroes"],
    }),
    //* *********************************************************** */
  }),
});

export const {
  useLazyGetLeadingZeroesQuery,
  usePostLeadingZeroesMutation,
  usePutLeadingZeroesMutation,
  useDeleteLeadingZeroesMutation,
} = leadingZeroesAPI;
